<template>
    <el-dialog
        :visible="visible"
        ref="DetailDialog"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        class="ah-detail-dialog"
        top="15vh"
        width="700px"
        append-to-body
        @close="onClose"
        @open="onOpen"
    >
        <ahUploader ref="ahUploader" accept="image/png, image/jpeg, .pdf, .txt, .xls, .xlsx" file-info @change="onChangeAttachment" />
        <template slot="title">
            <div class="title">
                <span v-if="isAdd">新增申報文件</span>
                <span v-else>編輯申報文件</span>
            </div>
        </template>
        <div class="ah-page application-form-management-edit-dialog">
            <div class="ah-container">
                <el-form ref="form" :model="form" :rules="rules" label-position="top" label-width="180px" v-loading="isLoading">
                    <div class="first-form-block">
                        <el-form-item prop="year" label="申報年度">
                            <el-select v-model="form.year" placeholder="年度" style="width: 130px">
                                <el-option v-for="item in yearList" :key="item" :label="item" :value="item" />
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="typ" label="申報類型">
                            <el-select v-model="form.typ" placeholder="請選擇" style="width: 130px" @change="onChangeTyp">
                                <el-option v-for="item in typList" :key="item.key" :label="item.label" :value="item.key" />
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="isPeriodSelectShow" prop="period" label="所屬期別" :rules="form.typ === 7 ? [] : rules.period">
                            <el-select v-model="form.period" placeholder="請選擇" style="width: 130px">
                                <el-option v-for="item in periodList" :key="item.key" :label="item.label" :value="item.key" />
                            </el-select>
                        </el-form-item>
                    </div>
                    <el-form-item v-if="isAdd" prop="url" :error="form.url ? null : '請選擇檔案'">
                        <template v-slot:label>
                            文件檔案<span style="font-size: 12px; color: #aaa; margin-left: 10px">(檔案大小上限：25MB)</span>
                        </template>
                        <div v-if="!form.url">
                            <el-button @click="onUploadFile">選擇檔案</el-button>
                        </div>
                        <div v-else style="display: flex">
                            <el-input :value="fileName" disabled style="width: 100%; margin-right: 20px"></el-input>
                            <el-button @click="onUploadFile">更換檔案</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item prop="nam" label="文件名稱">
                        <el-input v-model="form.nam" :maxlength="200" :show-word-limit="true"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="detail-row footer right">
                <div style="display: flex; justify-content: space-between">
                    <div>
                        <el-button v-if="!isAdd && !isQR()" type="danger" :loading="isLoading" @click="onDelete"> 刪除 </el-button>
                    </div>
                    <div>
                        <el-button :loading="isLoading" @click="onCancel"> 取消 </el-button>
                        <el-button type="primary" class="primary-action" :loading="isLoading" @click="onSubmit"> 送出 </el-button>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import ahUploader from '@/components/ui/Uploader/ahUploader.vue';
import { applicationFormTypOptions, monthOptions } from '@/assets/commonData/options';

export default {
    components: { ahUploader },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        sno: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            isLoading: false,
            fileName: null,
            form: {
                sno: null,
                year: null,
                typ: null,
                period: null,
                url: null,
                nam: null,
                filesize: null,
            },
            rules: {
                year: [
                    {
                        required: true,
                        message: '請填寫摘要',
                        trigger: 'blur',
                    },
                ],
                typ: [
                    {
                        required: true,
                        message: '請填寫申報類型',
                        trigger: 'blur',
                    },
                ],
                period: [
                    {
                        required: true,
                        message: '請選擇所屬期別',
                        trigger: 'blur',
                    },
                ],
                url: [
                    {
                        required: true,
                        message: '請選擇檔案',
                    },
                ],
                nam: [
                    {
                        required: true,
                        message: '請輸入文件名稱',
                        trigger: 'blur',
                    },
                ],
            },
            yearList: [],
            typList: [...applicationFormTypOptions],
        };
    },
    computed: {
        isAdd() {
            return this.sno === null;
        },
        periodList() {
            switch (this.form.typ) {
            case 1:
                return [
                    { key: 1, label: '1~2月' },
                    { key: 2, label: '3~4月' },
                    { key: 3, label: '5~6月' },
                    { key: 4, label: '7~8月' },
                    { key: 5, label: '9~10月' },
                    { key: 6, label: '11~12月' },
                ];
            case 2:
            case 5:
                return [...monthOptions.map((o) => ({ key: o.key, label: o.value }))];
            default:
                return [{ key: null, label: '全年' }, ...monthOptions.map((o) => ({ key: o.key, label: o.value }))];
            }
        },
        isPeriodSelectShow() {
            return this.form.typ && this.form.typ !== 3 && this.form.typ !== 4 && this.form.typ !== 6;
        },
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            const THIS_YEAR = moment().year();
            const THIS_MONTH = moment().month() + 1;
            for (let y = THIS_YEAR; y >= 2020; y -= 1) {
                this.yearList.push(y);
            }
            this.form.year = THIS_MONTH === 1 ? THIS_YEAR - 1 : THIS_YEAR;
        },
        resetForm() {
            this.form = {
                year: null,
                typ: null,
                period: null,
                url: null,
                nam: null,
                filesize: null,
            };
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });

            const THIS_YEAR = moment().year();
            const THIS_MONTH = moment().month() + 1;
            this.form.year = THIS_MONTH === 1 ? THIS_YEAR - 1 : THIS_YEAR;
        },
        async onOpen() {
            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });

            if (!this.isAdd) {
                try {
                    this.isLoading = true;
                    const resp = await this.$api({
                        url: 'Document/GetDocumentInfo',
                        method: 'GET',
                        params: { sno: this.sno },
                    });
                    this.form.sno = resp.data.item.sno;
                    this.form.year = resp.data.item.year;
                    this.form.typ = resp.data.item.typ;
                    this.form.period = resp.data.item.period;
                    this.form.url = resp.data.item.url;
                    this.form.nam = resp.data.item.nam;
                    this.form.filesize = resp.data.item.filesize;
                } finally {
                    this.isLoading = false;
                }
            }
        },

        onClose(refresh) {
            this.resetForm();
            this.$emit('close', refresh);
        },
        onCancel() {
            this.onClose();
        },
        async onDelete() {
            try {
                await this.$confirm('確定要刪除此文件？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });
                this.isLoading = true;
                await this.$api({
                    url: 'Document/DeleteDocument',
                    method: 'DELETE',
                    data: { sno: this.sno },
                });
                this.onClose(true);
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },

        onChangeTyp() {
            const THIS_MONTH = moment().month() + 1;
            switch (this.form.typ) {
            case 1:
                this.form.period = Math.ceil(THIS_MONTH / 2) === 1 ? 6 : Math.ceil(THIS_MONTH / 2) - 1;
                break;
            case 2:
            case 5:
                this.form.period = THIS_MONTH === 1 ? 12 : THIS_MONTH - 1;
                break;
            default:
                this.form.period = null;
            }
        },

        onSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    try {
                        this.isLoading = true;

                        await this.$api({
                            url: 'Document/UpsertDocument',
                            method: 'POST',
                            data: this.form,
                        });
                        this.onClose(true);
                    } finally {
                        this.isLoading = false;
                    }
                }
            });
        },

        onUploadFile() {
            this.$refs.ahUploader.onUploadFile();
        },
        onChangeAttachment(receiptData) {
            if (!receiptData) return;

            this.form.url = receiptData.filE_ATT;
            this.fileName = _.first(receiptData.fileInfo.name.split('.'));
            this.form.nam = this.fileName;
            this.form.filesize = receiptData.fileInfo.size;
        },
    },
};
</script>

<style lang="scss" scoped>
.application-form-management-edit-dialog {
    margin-top: 20px;
    padding-bottom: 0;
    .first-form-block {
        display: flex;
        > :not(:last-child) {
            margin-right: 20px;
        }
    }
}
</style>
